export default {
  ...Object.fromEntries(
    ['NODE_ENV', 'VUE_APP_BASE_URL', 'VUE_APP_API_BASE_URL', 'STRIPE_TOKEN', 'VUE_APP_SHADOWS'].map((x) => [
      x,
      process.env[x]
    ])
  )
}

// Card shadow/border class strings. Each combines:
// - shadow-solid-*   = solid shadow offset (solid-xs: -3px 3px, solid-xxs: -1px 1px; see tailwind boxShadow)
// - shadow-gray-brand-* = color of the shadow (tinted to brand)
// - border-gray-brand-*  = color of the 1px border
export const cardShadowClasses =
  process.env.VUE_APP_SHADOWS === 'light'
    ? 'shadow-solid-xxs shadow-gray-brand-400 border-gray-brand-400'
    : 'shadow-solid-xs shadow-gray-brand-500 border-gray-brand-500'

// The same chrome, held back until sm, for a card that is the whole page on a phone. Written out
// rather than built from the strings above because Tailwind only ships classes it can read here.
export const cardShadowClassesFromSm =
  process.env.VUE_APP_SHADOWS === 'light'
    ? 'sm:shadow-solid-xxs sm:shadow-gray-brand-400 sm:border-gray-brand-400'
    : 'sm:shadow-solid-xs sm:shadow-gray-brand-500 sm:border-gray-brand-500'

// Product card when item is in cart (darker shadow/border for emphasis).
export const productCardInCartShadowClasses =
  process.env.VUE_APP_SHADOWS === 'light'
    ? 'shadow-solid-xxs shadow-gray-brand-600 border-gray-brand-600'
    : 'shadow-solid-xs shadow-gray-brand-900 border-gray-brand-900'

export const inputFieldClasses =
  'block w-full h-12 appearance-none rounded-lg border bg-white px-3.5 text-base text-gray-brand-900 placeholder-gray-brand-500 focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-200'

export const inputBorderClass = (error) => (error ? 'border-red-500' : 'border-gray-brand-400')
